import * as React from "react";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { StreamEnum } from "src/library/types/types";

type StreamCheckboxesProps = {
  streams: number[];
  handleStreamChange: Function;
  style?: Object;
};

export default function StreamCheckboxes(props: StreamCheckboxesProps) {
  const { streams, handleStreamChange, style } = props;

  return (
    <>
      <FormLabel id="stream-label" sx={{ display: "flex", justifyContent: "flex-start" }}>
        <Typography
          variant="body1"
          fontWeight="fontWeightBold"
          textAlign="left"
          color="text.light"
        >
          Which stream do you wish to represent?
        </Typography>
      </FormLabel>
      <Box sx={{ display: "flex", flexDirection: "column", pl: 2 }}>
        <FormControlLabel
          label="Women in digital"
          control={
            <Checkbox
              name="stream"
              value={StreamEnum.Women}
              onChange={() => handleStreamChange(StreamEnum.Women)}
              checked={streams.includes(StreamEnum.Women)}
              sx={style}
            />
          }
        />
        <FormControlLabel
          label="First Nations in technology"
          control={
            <Checkbox
              name="stream"
              value={StreamEnum.Indigenous}
              onChange={() => handleStreamChange(StreamEnum.Indigenous)}
              checked={streams.includes(StreamEnum.Indigenous)}
              sx={style}
            />
          }
        />
        <FormControlLabel
          label="Accessibility in gaming"
          control={
            <Checkbox
              name="stream"
              value={StreamEnum.Gaming}
              onChange={() => handleStreamChange(StreamEnum.Gaming)}
              checked={streams.includes(StreamEnum.Gaming)}
              sx={style}
            />
          }
        />
      </Box>
    </>
  );
}
